import React, { useState } from "react";

const PositionTab = ({ updateBackToTopTabData,backToTopTabData }) => {
    const [positionType, setPositionType] = useState(backToTopTabData.position_type);
    const [positionTypeDropdownOpen, setPositionTypeDropdownOpen] = useState(false);
    const [position, setPosition] = useState(backToTopTabData.position);
    const [positionDropdownOpen, setPositionDropdownOpen] = useState(false);
    const [positionOffest, setPositionOffest] = useState(backToTopTabData.position_offest);
    
    // Handlers Position Type Change
    const handlePositionTypeChange = (type) => {
        setPositionType(type);
        updateBackToTopTabData("position_type", type);
        setPositionTypeDropdownOpen(false);
    };

    // Handlers Position Change
    const handlePositionChange = (type) => {
        setPosition(type);
        updateBackToTopTabData("position", type);
        setPositionDropdownOpen(false);
    };
   //Formated value
   const formatPositionLabel = (value) => {
        return value
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // Handlers Position Offest Change
    const handlePositionOffestChange = (e) => {
        const rawValue = parseInt(e.target.value, 10);
        // Define min and max constants for clarity
        const MIN_SIZE = 1;
        const MAX_SIZE = 20;
        // Clamp the value within the range
        const clampedValue = Math.max(MIN_SIZE, Math.min(rawValue, MAX_SIZE));
        const valueWithPx = `${clampedValue}px`;
        setPositionOffest(valueWithPx); 
        updateBackToTopTabData("position_offest", valueWithPx);
    };

    return (
        <div className="testimonials-side-baar-layout-tab">
            <span>Position</span>
            <div className="side-baar-box-header">
                <div className="box-header-row">
                    <span>Type</span>
                    <div className="color-pikr-box" onClick={() => setPositionTypeDropdownOpen(!positionTypeDropdownOpen)}>
                        <em>{positionType}</em>
                        {positionTypeDropdownOpen && (
                            <ul className="dropdown-list">
                                {["Floating","Embedded"].map((type) => (
                                    <li key={type} onClick={() => handlePositionTypeChange(type)}>
                                        {type}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>

                <div className="box-header-row">
                    <span>Position</span>
                    <div className="color-pikr-box" onClick={() => setPositionDropdownOpen(!positionDropdownOpen)}>
                        <em>{formatPositionLabel(position)}</em>
                        {positionDropdownOpen && (
                            <ul className="dropdown-list">
                                {["bottom_right","bottom","bottom_left","left","right","top_right","top","top_left"].map((type) => (
                                    <li key={type} onClick={() => handlePositionChange(type)}>
                                        {formatPositionLabel(type)}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </div>
                <div className="box-header-row">
                    <span>Offset</span>
                    <em>{positionOffest}</em>
                    <div className="slider-container">
                        <input type="range" min="1px" max="20px" value={parseInt(positionOffest)} onChange={handlePositionOffestChange}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PositionTab;